import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Store
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { DockingBarService, PageTitleService, SidebarService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'ds-report-claim-what-to-expect',
  templateUrl: './report-claim-what-to-expect.component.html',
  styleUrls: ['./report-claim-what-to-expect.component.scss'],
  standalone: false
})
export class ReportClaimWhatToExpectComponent implements OnInit, AfterViewInit {
  public sidebarPresent = false;

  // Shared subject for completing observables
  private stop$: Subject<void> = new Subject<void>();

  constructor(
    private store: Store<fromRoot.RootState>,
    private sidebarService: SidebarService,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService
  ) {}

  ngOnInit() {
    this.pageTitle.set('File a Claim - What to expect');
    this.dockingBarService.registerHeading('File a Claim - What to expect');
  }

  ngAfterViewInit() {
    window.setTimeout(() => {
      this.sidebarService.sidebarPresent$
        .pipe(takeUntil(this.stop$))
        .subscribe(present => (this.sidebarPresent = present));
    }, 0);
  }

  back() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/claims']
      })
    );
  }
}
